import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
import { NavLink } from 'react-router-dom';

import { Typography, Paper, Button, Divider, Box } from '@mui/material'
import Grid from '@mui/material/Grid';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import Needhelp from '../images/needhelp.jpg'
import Getstarted from '../images/getStarted.png';
import Personal from '../images/personal.png';
import OriginAndDestination from '../images/originanddestination.png';
import CurrencyInfomation from '../images/currencyInformation.png';
import Currency from '../images/currencies_background.jpg';
import ReviewandSign from '../images/reviewandSign.png';
import ShipReceive from '../images/shiprecv.png';
import ThirdParty from '../images/thirdparty.png';
import { LoadCombinedReference } from '../service/ReferenceData';
import Header from '../container/Header';
import { updateFormIncomplete } from '../actions'

import { resetStart, resetStep, resetPerson, resetAddress, resetThirdParty, resetMailShip, resetExportImport, 
            resetCurrencyItem, resetCoinItem, resetOtherItem, resetReviewSign, resetReceipt } from '../actions'

// const Landing = (props) => {
function Landing(props) {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const navigate = useNavigate();
  // const [recaptchaToken, setRecaptchaToken] = useState(props.recaptchaToken);

  let isStartDisabled = props.isStartDisabled

  const navform = e => {
    // console.log('in nav form')
    dispatch(resetStart())
    dispatch(resetStep())
    dispatch(resetPerson())
    dispatch(resetAddress())
    dispatch(resetExportImport())
    dispatch(resetMailShip())
    dispatch(resetThirdParty())
    dispatch(resetCurrencyItem())
    dispatch(resetCoinItem())
    dispatch(resetOtherItem())
    dispatch(resetReviewSign())
    dispatch(resetReceipt())

    dispatch(updateFormIncomplete(true))
    navigate('/form')
  };

  useEffect(() => {
    LoadCombinedReference();
    document.title = 'Home | FinCEN Form 105 | CMIR, U.S. Customs and Border Protection';
  }, []); // Empty dependency array means it runs once on mount

  const landingSx = {
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    float: 'left',
    width: '100%',
  };

  const landingHeaderSx = {
    display: 'flex',
    width: '100%',
    background: 'transparent',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  };

  const rootSx = {
    flexGrow: 1,
  };

  const topheaderSx = {
    padding: '0px 33px 3px 40px',
  };

  const currencytextSx = {
    color: '#1E1E1E',
    fontWeight: 'bold',
    fontSize: { xs: 15, sm: 'inherit' },
  };

  const currencytext1Sx = {
    color: '#1E1E1E',
    fontWeight: 'bold',
    display: { xs: 'none', sm: 'block' },
  };

  const needhelpTextSx = {
    marginLeft: '0px',
    fontWeight: 'bold',
    color: '#3440E4',
    textDecoration: 'none',
    textTransform: 'none'
  };

  const paperSx = {
    backgroundColor: '#1c3764',
    backgroundImage: "url(" + Currency + ")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top left",
    backgroundSize: "cover",
  };

  const formcardSx = {
    width: { xs: 336, sm: 496, md: 528 },
    marginTop: 8,
    marginBottom: 10,
    marginRight: { xs: 2, sm: 4, md: 6 },
    marginLeft: { xs: 2, sm: 'auto' },
    backgroundColor: '#ffffff',
    borderRadius: '8px',
  };

  const reportcard1Sx = {
    paddingTop: '12px',
    fontFamily: 'Roboto Medium, sans-serif, Roboto',
    fontSize: { xs: '16px', sm: '24px' },
    fontWeight: { xs: '600', sm: '500' },
    fontStyle: 'normal',
    lineHeight: '1.2',
  };

  const reportcard2Sx = {
    pb: 1,
    fontFamily: 'Roboto Medium, sans-serif, Roboto',
    fontSize: { xs: '16px', sm: '24px' },
    fontWeight: { xs: '600', sm: '500' },
    fontStyle: 'normal',
    lineHeight: '1.2',
  };

  const formtext1Sx = {
    color: '#1E1E1E',
    fontWeight: { xs: '500', sm: '600' },
    fontSize: { xs: '0.85rem', sm: '18px' },
    paddingTop: { xs: '8px', sm: '20px' },
    lineHeight: '1.2',
  };

  const formtext2Sx = {
    color: '#1E1E1E',
    fontWeight: { xs: '500', sm: '600' },
    fontSize: { xs: '0.85rem', sm: '18px' },
    lineHeight: '1.2',
  };

  const buttonSx = {
    ml: { xs: 6, sm: 5.4 },
    mr: { xs: 4, sm: 1 },
    mt: '20px',
    mb: '20px',
    width: { xs: 240, sm: 432 },
    height: '48px',
    borderRadius: '16px',
    backgroundColor: '#142849',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
    fontFamily: 'Roboto Medium, sans-serif, Roboto',
    fontSize: '19px',
    fontWeight: '600',
    textTransform: 'none',
  };

  const subpaperSx = {
    paddingTop: '20px',
    paddingBottom: '20px',
    color: 'text.primary',
    backgroundColor: '#DCDCDC'
  };

  const formfillSx = {
    paddingBottom: '24px',
    color: '#895505',
    fontWeight: 'bold',
    fontSize: { xs: '0.88rem', sm: 'inherit' },
    marginTop: { xs: 12, sm: 0 }
  };

  const stepslineSx = {
    height: 30,
    color: '#895505',
    marginRight: '30px',
    fontWeight: 'bold',
    display: { xs: 'none', lg: 'inline' }
  };

  const heightStepsSx = {
    justifyContent: 'center',
    height: { xs: '260px', sm: '280px', md: '120px' }
  };

  const imageSizeSx = {
    height: { xs: '38px', sm: '44px', md: '45px', lg: '55px' }
  };

  const stepsdividerSx = {
    backgroundColor: '#895505',
  };

  const numberFontSx = {
    height: '31px',
    color: '#895505',
    fontSize: 37,
    marginBlockStart: '0px',
    marginBlockEnd: '0px'
  };

  const getStartedSx = {
    height: 1,
    color: '#483D8B',
    fontWeight: '500',
    paddingLeft: '3px',
    marginBlockStart: '0px',
    marginBlockEnd: '0px'
  };

  const fillerverticalSx = {
    paddingTop: '32px',
    paddingBottom: '16px'
  };

  const iconBarSx = {
    height: 100,
    mt: { xs: 16, sm: 20, lg: 5 }
  };

  const button2Sx = {
    ml: { xs: 3, sm: 2 },
    mr: { sm: 1 },
    mt: { xs: 8, sm: '20px' },
    mb: '20px',
    width: { xs: 240, sm: 448 },
    height: '48px',
    borderRadius: '16px',
    backgroundColor: '#142849',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
    fontFamily: 'Roboto Medium, sans-serif, Roboto',
    fontSize: '19px',
    fontWeight: '600',
    textTransform: 'none',
  };

  const modalSx = {
    fontSize: '1rem',
    opacity: '1',
    backgroundColor: 'white',
  };

  const modalHeaderSx = {
    textTransform: 'uppercase',
    fontSize: { xs: '18px', sm: '20px' },
    fontWeight: '500',
    textAlign: 'center',
    mt: '12px',
    mb: '14px',
    lineHeight: '1.1',
  };

  const modalContentSx = {
    mb: 3,
    fontSize: { xs: '12px', sm: '16px' },
    padding: '15px',
    position: 'relative',
    fontFamily: 'Roboto,Calibri,Tahoma,Arial,sans-serif',
  };

  const buttonBarSx = {
    height: 68,
  };

  const cancelButtonSx = {
    ml: 1,
    mr: 1,
    width: { xs: 115, sm: 150 },
    fontSize: { xs: '0.625rem', sm: '0.86rem' },
    borderColor: "#324bb5",
    color: "#324bb5",
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      borderColor: '#1976d2',
      backgroundColor: 'rgba(50, 75, 181, 0.04)',
    },
  };

  const confirmButtonSx = {
    ml: 1,
    mr: 1,
    width: { xs: 149, sm: 200 },
    fontSize: { xs: '0.625rem', sm: '0.86rem' },
    backgroundColor: "#324bb5",
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  };

  return (
    <Grid sx={landingSx}>
      <Header />
      <Grid sx={landingHeaderSx}>

      <Grid sx={rootSx} >
          <Grid container sx={{...topheaderSx, alignItems: "center", justifyContent: "space-between", flexDirection: "row"}}>
            <Grid>
                <Grid container sx={{alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "row"}}>
                  <Grid role="heading" aria-level="4" sx={currencytextSx}>FinCEN Form 105</Grid>              
                  <Grid role="heading" aria-level="4" sx={currencytext1Sx} ><span>&nbsp;</span>| Currency and Monetary Instrument Report (CMIR)</Grid>
                </Grid>  
              </Grid>
              
              <Grid>
                <NavLink to="/help" target="help" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
                  <Grid container sx={{alignItems: "center", justifyContent: "space-between", flexDirection: "row"}}>
                    <Box component="img" src={Needhelp} alt="needhelp" sx={{cursor: 'pointer'}}/>
                    <Button autoCapitalize="false" sx={needhelpTextSx}  align="center">Need Help?</Button>
                  </Grid>
                </NavLink>
              </Grid>
            </Grid>

            <Grid container sx={{...paperSx, alignItems: "center", justifyContent: "flex-end", flexDirection: "row"}}> 
                <Grid>
                  <Paper sx={formcardSx}>
                    <Typography role="heading" aria-level="2" align="center" sx={reportcard1Sx}>
                        Report of International Transportation
                    </Typography>
                    <Typography role="heading" aria-level="2" align="center" sx={reportcard2Sx}>
                        of Currency or Monetary Instruments
                    </Typography>
                    <Typography align="center" sx={formtext1Sx}>                  
                        This form is available for filing to travelers and                   
                    </Typography>                  
                    <Typography align="center" sx={formtext2Sx}>
                        currency transporters when entering or departing
                    </Typography>
                    <Typography align="center" sx={formtext2Sx}>
                        or shipping or receiving from / to the United States                    
                    </Typography>
                    <Typography align="center" sx={formtext2Sx}>
                        with an aggregate amount exceeding $10,000                       
                    </Typography>
                    <Button variant="contained" size="small" color="primary" disabled={isStartDisabled} onClick={() => setOpen(o => !o)} sx={buttonSx}>
                      Get Started
                    </Button>                
               </Paper>
            </Grid>          
        </Grid>

        <Grid sx={subpaperSx} >
          <Grid role="heading" aria-level="4" container sx={{...formfillSx, alignItems: "center", justifyContent: "center"}} >       
            <Box component="p" sx={stepslineSx}> ________________________________</Box> 
                  Steps for Filling out Form for Others
            <Box component="p" sx={{...stepslineSx, marginLeft: '27px'}}>  _______________________________________</Box>
          </Grid>

          <Grid container spacing={8} sx={heightStepsSx} >
            <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                  <Box component="img" sx={imageSizeSx} src={Getstarted} aria-hidden="true"/>
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>1</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Get<br></br>Started</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>

            <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                <Box component="img" sx={imageSizeSx} src={Personal} aria-hidden="true" />
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>2</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Personal<br></br>Information</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>

            <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                <Box component="img" sx={imageSizeSx} src={OriginAndDestination} aria-hidden="true" />
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>3</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Origin and<br></br>Destination</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>

            <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                <Box component="img" sx={imageSizeSx} src={CurrencyInfomation} aria-hidden="true" />
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>4</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Monetary<br></br>Instruments</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>

            <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                <Box component="img" sx={imageSizeSx} src={ReviewandSign} aria-hidden="true" />
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>5</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Review<br></br>and Sign</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>
          </Grid>

          <Grid sx={subpaperSx} >
            <Grid role="heading" aria-level="4" container sx={{...formfillSx, alignItems: "center", justifyContent: "center"}} >       
              <Box component="p" sx={stepslineSx}> ____________________________</Box> 
                    Steps for Filling out Form for Currency Transporter
              <Box component="p" sx={{...stepslineSx, marginLeft: '27px'}}>  ___________________________________</Box>
            </Grid>

            <Grid container spacing={8} sx={heightStepsSx} >
              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                    <Box component="img" sx={imageSizeSx} src={Getstarted} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>1</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Get<br></br>Started</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                  <Box component="img" sx={imageSizeSx} src={Personal} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>2</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Personal<br></br>Information</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                  <Box component="img" sx={imageSizeSx} src={OriginAndDestination} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>3</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Origin and<br></br>Destination</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                  <Box component="img" sx={{...imageSizeSx, paddingLeft: '17px' }} src={ShipReceive} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>4</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Shipper and<br></br>Receiver</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                  <Box component="img" sx={imageSizeSx}  src={ThirdParty} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>5</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Third<br></br>Party</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
                <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                  <Grid>
                  <Box component="img" sx={imageSizeSx} src={CurrencyInfomation} aria-hidden="true" />
                    <Divider sx={stepsdividerSx} />
                    <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                      <Grid>
                        <Box component="p" sx={numberFontSx}>6</Box>
                      </Grid>  
                      <Grid>  
                        <Box component="p" sx={getStartedSx}>Monetary<br></br>Instruments</Box>
                      </Grid>  
                    </Grid>     
                  </Grid>   
                </Grid>
              </Grid>

              <Grid xs={12} md={2}>          
              <Grid container sx={{alignItems: "center", flexDirection: "column"}} >
                <Grid>
                <Box component="img" sx={imageSizeSx} src={ReviewandSign} aria-hidden="true" />
                  <Divider sx={stepsdividerSx} />
                  <Grid container sx={{alignItems: "flex-start", justifyContent: "space-evenly", flexDirection: "row"}} >
                    <Grid>
                      <Box component="p" sx={numberFontSx}>7</Box>
                    </Grid>  
                    <Grid>  
                      <Box component="p" sx={getStartedSx}>Review<br></br>and Sign</Box>
                    </Grid>  
                  </Grid>     
                </Grid>   
              </Grid>
            </Grid>
            </Grid>
          </Grid>

          <Grid sx={fillerverticalSx}>
            <Grid container sx={{...iconBarSx, justifyContent: "center", alignItems: "center", flexDirection: "row"}}>
              <Button variant="contained" size="small" color="primary" disabled={isStartDisabled} onClick={() => setOpen(o => !o)} sx={button2Sx}>
                Get Started
              </Button>
            </Grid>
          </Grid>
        </Grid>
        </Grid>

        <Popup contentStyle={{ width: "80%" }} open={open} closeOnDocumentClick onClose={closeModal}>
          <Grid sx={modalSx}>
            <Grid role="heading" aria-level="4" sx={modalHeaderSx}>SECURITY NOTIFICATION</Grid>
            
            <hr/>
            <Grid sx={modalContentSx}>
            You are about to access a Department of Homeland Security computer system. This computer system and data 
            therein are property of the U.S. Government and provided for official U.S. Government information and use. There is no expectation of privacy when 
            you use this computer system. The use of a password or any other security measure does not establish an expectation of privacy. By using this system, 
            you consent to the terms set forth in this notice. You may not process classified national security information on this computer system. Access to this system 
            is restricted to authorized users only. Unauthorized access, use, or modification of this system or of data contained herein, or in transit to/from this system, 
            may constitute a violation of section 1030 of title 18 of the U.S. Code and other criminal laws. Anyone who accesses a Federal computer system without 
            authorization or exceeds access authority, or obtains, alters, damages, destroys, or discloses information, or prevents authorized use of information on 
            the computer system, may be subject to penalties, fines or imprisonment. This computer system and any related equipment is subject to monitoring for 
            administrative oversight, law enforcement, criminal investigative purposes, inquiries into alleged wrongdoing or misuse, and to ensure proper performance 
            of applicable security features and procedures. DHS may conduct monitoring activities without further notice.
            </Grid>                
          <hr/>

          </Grid>
          <Grid container sx={{...buttonBarSx, justifyContent: "space-between", alignItems: "center", flexDirection: "row"}}>
                <Button variant="outlined" color="secondary" onClick={closeModal} sx={cancelButtonSx}>Cancel & Exit</Button>
                <Button variant="contained" color="primary" onClick={navform} sx={confirmButtonSx}>Confirm & Continue</Button>
              </Grid>
        </Popup>

      </Grid>
    </Grid>
  );
}

export default Landing;